export default {

    'project.app.Footer.text': 'PA Project - Area de Ingeniería Telemática - Universidad de A Coruña',
    'project.app.Header.home': 'Inicio',
    'project.app.Header.logout': 'Salir',
    'project.app.Home.welcome': '¡Contenido de la página principal de PA Project!',
    

    'project.global.buttons.addStep': 'Añadir Paso',
    'project.global.buttons.previousStep': 'Paso Anterior',
    'project.global.buttons.nextStep': 'Siguiente Paso',
    'project.global.buttons.Play1': 'Reproducir',
    'project.global.buttons.Stop': 'Parar',

    'project.global.buttons.undo': 'Deshacer',
    'project.global.buttons.clear': 'Borrar',
    'project.global.buttons.download': 'Descargar',

    'project.global.buttons.team_selection': 'Selección de Equipo',
    'project.global.buttons.season_selection': 'Selección de Temporada',
    'project.global.buttons.player_selection': 'Selección de Jugadores',
    'project.global.buttons.exercises_selection': 'Selección de Ejercicios',
    'project.global.buttons.stretching_selection': 'Selección de Estiramientos',
    'project.global.buttons.lesion_selection': 'Selección de Lesiones',
    'project.global.buttons.play_selection': 'Selección de Jugadas',

    'project.calendar.buttons.editEvent': 'Editar Evento',
    'project.calendar.buttons.addEvent': 'Añadir Evento',
    'project.calendar.buttons.deleteEvent': 'Eliminar Evento',


























    'project.common.ErrorDialog.title': 'Error',
    'project.global.buttons.signin': 'Iniciar Sesión',
    'project.global.buttons.filter': 'Filtro',

    'project.global.buttons.charts': 'Gráficos',
    'project.global.buttons.calendar': 'Calendario',
    'project.global.buttons.users': 'Usuarios',

    'project.global.list.users': 'Lista de Usuarios',
    'project.global.create.users': 'Crear Usuario',
    'project.users.fields.remove' : 'Eliminar',

    'project.global.buttons.board': 'Pizarra',
    'project.global.buttons.animation': 'Animación',
    'project.global.buttons.general': 'General',

    'project.global.buttons.statistics': 'Estadísticas',
    'project.global.buttons.home': 'Inicio',

    
    'project.global.buttons.find': 'Buscar',
    'project.global.buttons.cancel': 'Cancelar',
    'project.global.buttons.close': 'Cerrar',
    'project.global.buttons.next': 'Siguiente',
    'project.global.buttons.ok': 'OK',
    'project.global.buttons.back': 'Anterior',
    'project.global.buttons.save': 'Guardar',
    'project.global.exceptions.NetworkError': 'Fallo de comunicación',
    'project.global.fields.date': 'Fecha',
    'project.global.fields.email': 'Correo electrónico',
    'project.global.fields.firstName': 'Nombre',
    'project.global.fields.lastName': 'Apellidos',
    'project.global.fields.name': 'Nombre',
    'project.global.fields.role': 'Rol',
    'project.global.fields.password': 'Contraseña',

    'project.global.fields.currentPassword': 'Contraseña Actual',
    'project.global.fields.newPassword': 'Nueva Contraseña',
    'project.global.fields.confirmPassword': 'Confirmar Contraseña',


    'project.global.fields.postalAddress': 'Dirección postal',
    'project.global.fields.postalCode': 'Código postal',
    'project.global.fields.userName': 'Usuario',
    'project.global.fields.userName1': 'Nombre de Usuario',
    'project.global.validator.email': 'Introduzca una dirección de correo electrónico correcta',
    'project.global.validator.passwordsDoNotMatch': 'Las contraseñas no coinciden',
    'project.global.validator.required': 'Campo obligatorio',

    'project.users.ChangePassword.fields.confirmNewPassword': 'Confirmar contraseña nueva',
    'project.users.ChangePassword.fields.newPassword': 'Contraseña nueva',
    'project.users.ChangePassword.fields.oldPassword': 'Contraseña antigua',
    'project.users.ChangePassword.title': 'Cambiar contraseña',
    'project.users.Login.title': 'Autenticarse',
    'project.users.SignUp.fields.confirmPassword': 'Confirmar contraseña',
    'project.users.SignUp.title': 'Registrarse',
    'project.users.UpdateProfile.title': 'Actualizar perfil',
    
    'project.users.profile.title': 'Perfil',


    'project.teams.FindTeamByName.noTeam': 'No se encontraron equipos',
    'project.seasons.FindSeason.noSeason': 'No se encontraron temporadas',

    'project.teams.fields.teams' : 'Equipos',
    'project.seasons.fields.seasons' : 'Temporadas',
    'project.lesion.fields.lesion' : 'Lesiones',
    'project.trainings.fields.trainings' : 'Entrenamientos',
    'project.games.fields.games' : 'Partidos',
    'project.stretchings.fields.stretchings' : 'Estiramientos',
    'project.exercises.fields.exercises' : 'Ejercicios',

    'project.players.fields.players' : 'Jugadores',
    'project.statistics.fields.addGameStatistics' : 'Añadir Estadísticas Partido',
    'project.statistics.fields.game' : 'Estadísticas Partido',

    'project.teams.fields.team' : 'Equipo',
    'project.seasons.fields.season' : 'Temporada',
    'project.games.fields.game' : 'Partido',
    'project.players.fields.player' : 'Jugador',

    //exercises
    'project.exercises.fields.addExercise' : 'Añadir Ejercicio',
    'project.exercises.fields.updateExercise' : 'Actualizar Ejercicio',
    'project.exercises.fields.name' : 'Nombre',
    'project.exercises.fields.description' : 'Descripción',
    'project.exercises.fields.objective' : 'Objetivo',
    'project.exercises.fields.type' : 'Tipo Ejercicio',
    'project.exercises.fields.typeOnly' : 'Tipo',
    'project.exercises.fields.tactic' : 'Táctico',
    'project.exercises.fields.technique' : 'Técnico',
    'project.exercises.fields.physical' : 'Físico',
    'project.exercises.fields.globalized' : 'Global',
    'project.exercises.fields.specific' : 'Específico',
    'project.exercises.fields.psychological' : 'Psicológico',
    'project.exercises.fields.strategy' : 'Estrategia',
    'project.exercises.fields.preMatch' : 'PrePartido',

    'project.exercises.fields.myExercises' : 'Mis Ejercicios',


    //games
    'project.games.fields.addGame' : 'Añadir Partido',
    'project.games.fields.updateGame' : 'Actualizar Partido',
    'project.games.fields.date' : 'Fecha',
    'project.games.fields.rival' : 'Rival',
    'project.games.fields.myGames' : 'Mis Partidos',
    'project.games.fields.removeGame' : 'Eliminar Partido',

    //lesion
    'project.lesion.fields.addLesion' : 'Añadir Lesión',
    'project.lesion.fields.updateLesion' : 'Actualizar Lesión',
    'project.lesion.fields.lesionName' : 'Nombre',
    'project.lesion.fields.medication' : 'Medicación',
    'project.lesion.fields.lesionType' : 'Tipo',
    'project.lesion.fields.muscle' : 'Muscular',
    'project.lesion.fields.tendon' : 'Tendinosa',
    'project.lesion.fields.joint' : 'Articular',
    'project.lesion.fields.spine' : 'Columna Vertebral',
    'project.lesion.fields.psychological' : 'Psicologica',
    'project.lesion.fields.withLesion' : 'Lesionados',
    'project.lesion.fields.myLesion' : 'Mis Lesiones',
    'project.lesion.fields.injured' : 'Lesionado',

    //notes
    'project.notes.fields.note' : 'Nota',
    'project.notes.fields.addNote' : 'Añadir Nota',
    'project.notes.fields.updateNote' : 'Actualizar Nota',
    'project.notes.fields.title' : 'Título',
    'project.notes.fields.myNotes' : 'Mis Notas',
    'project.notes.fields.notes' : 'Notas',

    //players
    'project.players.fields.addPlayer' : 'Añadir Jugador',
    'project.players.fields.updatePlayer' : 'Actualizar Jugador',
    'project.players.fields.name' : 'Nombre',
    'project.players.fields.playerName' : 'Nombre',
    'project.players.fields.primaryLastName' : 'Primer Apellido',
    'project.players.fields.secondLastName' : 'Segundo Apellido',
    'project.players.fields.position' : 'Posición',
    'project.players.fields.pointGuard' : 'Base',
    'project.players.fields.shootingGuard' : 'Escolta',
    'project.players.fields.smallForward' : 'Alero',
    'project.players.fields.powerForward' : 'Ala Pívot',
    'project.players.fields.center' : 'Pívot',
    'project.players.fields.trends' : 'Tendencias',
    'project.players.fields.phoneNumber' : 'Número Tfl',
    'project.players.fields.email' : 'Email',
    'project.players.fields.dni' : 'Dni',
    'project.players.fields.findPlayerByDni' : 'Buscar Jugador por Dni',
    'project.players.fields.findPlayerByNameAndSurnames' : 'Buscar Jugador por nombres y apellidos',
    'project.players.fields.nameAndSurnames' : 'Nombre y Apellidos',
    'project.players.fields.clear' : 'Reiniciar',

    //plays
    'project.plays.fields.addPlay' : 'Añadir Jugada',
    'project.plays.fields.updatePlay' : 'Actualizar Jugada',
    'project.plays.fields.play' : 'Jugada',
    'project.plays.fields.attack' : 'Ataque',
    'project.plays.fields.defense' : 'Defensa',
    'project.plays.fields.gesture' : 'Gesto',
    'project.plays.fields.pointGuardText' : 'Base Texto',
    'project.plays.fields.shootingGuardText' : 'Escolta Texto',
    'project.plays.fields.smallForwardText' : 'Alero Texto',
    'project.plays.fields.powerForwardText' : 'Ala Pívot Texto',
    'project.plays.fields.centerText' : 'Pívot Texto',

    //seasons
    'project.seasons.fields.addSeason' : 'Añadir Temporada',
    'project.plays.fields.updateSeason' : 'Actualizar Temporada',
    'project.seasons.fields.startDate' : 'Fecha Inicio',
    'project.seasons.fields.endDate' : 'Fecha Fin',
    'project.seasons.fields.name' : 'Nombre',
    'project.seasons.fields.allSeasons' : 'Temporadas',
    'project.seasons.fields.seasonsBetweenTwoDates' : 'Temporadas por fechas',


    //statistics
    'project.statistics.fields.myteam' : 'Mi Equipo',
    'project.statistics.fields.myrival' : 'Rival',
    'project.statistics.fields.playerGameStatistics' : 'Estadísticas Jugador Partido',
    'project.statistics.fields.statistics' : 'Estadísticas',

    'project.statistics.fields.totalPoints' : 'Total Puntos ',
    'project.statistics.fields.totalPointsTeam1' : 'Puntos Equipo',
    'project.statistics.fields.totalPointsRival1' : 'Puntos Rival',

    'project.statistics.fields.totalThreePointShots' : 'Tiros de 3',
    'project.statistics.fields.totalSetShots' : 'Tiros de campo',
    'project.statistics.fields.totalFreeShots' : 'Tiros libres',

    'project.statistics.fields.totalFailThreePointShots' : 'Total tiros de 3 fallados',
    'project.statistics.fields.totalfailSetShots' : 'Total tiros de campo fallados',
    'project.statistics.fields.totalfailFreeShots' : 'Total tiros libres fallados',

    'project.statistics.fields.totalRebounds' : 'Rebotes',
    'project.statistics.fields.totalBlockedShot' : 'Tapones',
    'project.statistics.fields.totalAssists' : 'Asistencias',

    'project.statistics.fields.totalPersonalFouls' : 'Faltas Personales',
    'project.statistics.fields.totalTechnicalFouls' : 'Faltas Técnicas',
    'project.statistics.fields.totalUnsportsmanlikeFouls' : 'Faltas Antideportivas',
    'project.statistics.fields.totalFouls' : 'Faltas',

    'project.statistics.fields.team_rival' : '(Mi Equipo - Rival)',


    'project.statistics.fields.addPlayerGameStatistics' : 'Añadir Estadísticas Jugador Partido',

    'project.statistics.fields.duration' : 'Duración (min)',
    'project.statistics.fields.minutes' : 'Minutos',

    'project.statistics.fields.totalPointsRival' : 'Total Puntos Rival ',
    'project.statistics.fields.totalThreePointShotsRival' : 'Tiros de 3 Rival',
    'project.statistics.fields.totalSetShotsRival' : 'Tiros de campo Rival',
    'project.statistics.fields.totalFreeShotsRival' : 'Tiros libres Rival',

    'project.statistics.fields.totalReboundsRival' : 'Total Rebotes Rival',
    'project.statistics.fields.totalBlockedShotRival' : 'Total Tapones Rival',
    'project.statistics.fields.totalAssistsRival' : 'Total Asistencias Rival',

    'project.statistics.fields.totalPersonalFoulsRival' : 'Total Faltas Personales Rival',
    'project.statistics.fields.totalTechnicalFoulsRival' : 'Total Faltas Técnicas Rival',
    'project.statistics.fields.totalUnsportsmanlikeFoulsRival' : 'Total Faltas Antideportivas Rival',



    'project.statistics.fields.threePointShots' : 'Tiros de 3',
    'project.statistics.fields.setShots' : 'Tiros de campo',
    'project.statistics.fields.freeShots' : 'Tiros libres',

    'project.statistics.fields.failShots' : 'Fallados',

    'project.statistics.fields.shotsFailed' : 'Tiros fallados',
    'project.statistics.fields.shots' : 'Tiros anotados',


    
    'project.statistics.fields.failThreePointShots' : 'Tiros de 3 fallados',
    'project.statistics.fields.failSetShots' : 'Tiros de campo fallados',
    'project.statistics.fields.failFreeShots' : 'Tiros libres fallados',

    'project.statistics.fields.rebounds' : 'Rebotes',
    'project.statistics.fields.blockedShot' : 'Tapones',
    'project.statistics.fields.assists' : 'Asistencias',

    'project.statistics.fields.personalFouls' : 'Faltas Personales',
    'project.statistics.fields.technicalFouls' : 'Faltas Técnicas',
    'project.statistics.fields.unsportsmanlikeFouls' : 'Faltas Antideportivas',

    'project.statistics.fields.update' : 'Actualizar',
    'project.statistics.fields.updateGameStatistics' : 'Actualizar Estadísticas Partido',
    'project.statistics.fields.updatePlayerGameStatistics' : 'Actualizar Estadísticas Jugador Partido',


    //stretchings
    'project.stretchings.fields.addStretching' : 'Añadir Estiramiento',
    'project.stretchings.fields.myStretchings' : 'Mis Estiramientos',

    'project.stretchings.fields.stretchingName' : 'Nombre',
    'project.stretchings.fields.stretchingType' : 'Tipo',
    'project.stretchings.fields.hamstrings' : 'Isquiotibiales',
    'project.stretchings.fields.buttocks' : 'Glúteos',
    'project.stretchings.fields.calf' : 'Gemelos',
    'project.stretchings.fields.adductors' : 'Adductores',
    'project.stretchings.fields.shoulder' : 'Hombro',
    'project.stretchings.fields.quadriceps' : 'Cuádriceps',
    'project.stretchings.fields.back' : 'Espalda',
    'project.stretchings.fields.pectoral' : 'Pectoral',
    'project.stretchings.fields.crotch' : 'Ingle',
    'project.stretchings.fields.triceps' : 'TrÍceps',
    'project.stretchings.fields.updateStretching' : 'Actualizar Estiramiento',
    
    //teams
    'project.teams.fields.changeTeam' : 'Cambiar Equipo',

    'project.teams.fields.name' : 'Nombre',
    'project.teams.fields.arena' : 'Estadio',
    'project.teams.fields.owner' : 'Propietario',

    'project.teams.fields.addTeamToSeason' : 'Añadir Equipo a Temporada',

    'project.teams.fields.addTeam' : 'Añadir Equipo',
    'project.teams.fields.updateTeam' : 'Actualizar Equipo',
    'project.teams.fields.teamName' : 'Nombre Equipo',

    'project.plays.fields.plays' : 'Jugadas',


    'project.teams.fields.allTeams' : 'Equipos',

    //trainings
    'project.trainings.fields.addTraining' : 'Añadir Entrenamientos',
    'project.trainings.fields.myTrainings' : 'Mis Entrenamientos',
    'project.trainings.fields.removeTraining' : 'Eliminar Entrenamientos',

    'project.trainings.fields.updateTraining' : 'Actualizar Entrenamientos',
    
    'project.trainings.fields.objective' : 'Objetivo',

    'project.trainings.fields.training' : 'Entrenamiento',
    'project.trainings.fields.durationOnly' : 'Duración',

    //sidebar
    'project.sidebar.fields.club' : 'Club',
    'project.sidebar.fields.events' : 'Eventos',
    'project.sidebar.fields.physicalHealth' : 'Bienestar',
}
